import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class LabelResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.pk = () => this.label?.key || this.tooltip?.key;
    }
}
LabelResource.urlRoot = apiResourceUrl("resources/labels");
//# sourceMappingURL=LabelResource.js.map